export const MODAL_COUNTDOWN_TIME = 0.2 * 60 * 1000;
export const DATE_FORMAT = 'YYYY-MM-DD';
